import $ from 'jquery';
import { throttle } from 'lodash';

const CLASSES = {
    active: 'active',
    submenu: 'submenu',
    searchActive: 'search-active',
};

class Top {
    constructor(el) {
        this.el = el;
        this.burgerEl = el.find('.top__burger');
        this.menusEl = el.find('.top__menus');
        this.submenus = el.find('.top__menu > li a');
        this.menusLinksEl = this.menusEl.find('.top__menu > li > a');
        this.searchBtnEl = el.find('.supermenu--search');
        this.searchCloseEl = el.find('.top__search__close');
        /**
         * Events
         */
        this.burgerEl.on('click', this.onClickBurger.bind(this));
        this.menusEl.on('click', '.top__submenu__back', (e) => {
            this.onClickBack($(e.target).parents('li'));
        });
        this.searchBtnEl.on('click', () => {
            this.toggleSearchActive();
        });
        this.searchCloseEl.on('click', () => {
            this.toggleSearchActive();
        });
        this.menusLinksEl.on('click', this.onClickMenuHeaderLink.bind(this));
        this.lastWindowPosition = $(window).scrollTop();
        $(window).scroll(throttle(this.onScroll, 200).bind(this));

        $(window).click(this.onClickOutsideOfMenu.bind(this));

    }
    onClickOutsideOfMenu(e) {
        if ($(e.target).closest('.top__menu').length || !this.currentSubmenu) {
            return;
        }
        this.currentSubmenu.removeClass(CLASSES.active);
    }
    onScroll() {
        //hides navigation bar when scrolling down and shows it when scrolling up
        if (this.burgerEl.hasClass(CLASSES.active)) {
            this.el.removeClass('top--hide');
            return;
        }
        let scrollDelta = $(window).scrollTop() - this.lastWindowPosition;

        if ($(window).scrollTop() > this.el.outerHeight() &&
            scrollDelta > 300) {

            this.lastWindowPosition = $(window).scrollTop();
            this.el.addClass('top--hide');
        } else if (scrollDelta < -20 || $(window).scrollTop() === 0) {

            this.lastWindowPosition = $(window).scrollTop();
            this.el.removeClass('top--hide');
        }
    }
    onClickMenuHeaderLink(event) {
        const closestSubmenu = $(event.target).closest('li');
        if (!closestSubmenu.hasClass(CLASSES.active)) {
            event.preventDefault();
            if (!this.currentSubmenu) {
                this.currentSubmenu = closestSubmenu;
            }
            this.currentSubmenu.removeClass(CLASSES.active);
            closestSubmenu.addClass(CLASSES.active);
            this.currentSubmenu = closestSubmenu;

        }
    }
    onClickBurger() {
        this.burgerEl.toggleClass(CLASSES.active);
        this.menusEl.toggleClass(CLASSES.active);
    }
    onClickBack(li) {
        this.menusEl.removeClass(CLASSES.submenu);
        li.removeClass(CLASSES.active);
    }
    toggleSearchActive() {
        this.el.toggleClass(CLASSES.searchActive);
    }
}

export default Top;